<template>
<div>
	<header style="
		padding:  50px;
		text-align:  center;
		background: #0055a9;
		height:180px;
		position: sticky;
		margin-bottom: 30px;
		" v-if="!showEmptyCart && !done">
		<h1 style="color: white;    font-size: 2.6em!important;text-transform: none;">{{ strings.checkout }}</h1>
		<h2 style="color: white;">{{ timer }}</h2>
	</header>
	<div class="container layout" v-if="!showEmptyCart && !done" style="margin-bottom: 150px;">
		<form ref="form" @submit="checkForm">
		<div class="row">
			<div class="col-lg-7 col-xl-7">
				<!-- Your details -->
				<h2 class="checkout-title">{{ strings.yourDetails }}</h2>
					<div>
					<label class="form__label input-group__item">{{ strings.name }}
					<input v-validate="'required'" :class="{'input': true, 'form--invalid': errors.has('name') }" type="text" :data-vv-as="strings.name" name="name" class="form__input" :placeholder="strings.yourname" v-model="ck_name">
					<p v-show="errors.has('name')" class="form__note">{{ errors.first('name') }}</p>
						<span>{{ errors.first('name') }}</span>
					</label>

					<label class="form__label input-group__item">{{ strings.lname }}
					<input v-validate="'required'" :class="{'input': true, 'form--invalid': errors.has('lname') }" type="text" :data-vv-as="strings.lname" name="lname" class="form__input" :placeholder="strings.yourlastname" v-model="ck_lname">
					<p v-show="errors.has('lname')" class="form__note">{{ errors.first('lname') }}</p>
					</label>

					<label class="form__label input-group__item">{{ strings.email }}
					<input v-validate="'required|email'" :class="{'input': true, 'form--invalid': errors.has('email') }" type="text" :data-vv-as="strings.email" name="email" class="form__input" :placeholder="strings.youremail" v-model="ck_email">
					<p v-show="errors.has('email')" class="form__note">{{ errors.first('email') }}</p>
					</label>

					<label class="form__label input-group__item">{{ strings.phone }}<span class="aside__detail"> {{ strings.includingDialCode }}</span>
					<input v-validate="'required'" :class="{'input': true, 'form--invalid': errors.has('phone') }" type="text" :data-vv-as="strings.phone" name="phone" class="form__input" :placeholder="strings.phoneNumber" v-model="ck_phone">
					<p v-show="errors.has('phone')" class="form__note">{{ errors.first('phone') }}</p>
					</label>

					<label class="form__label input-group__item">{{ strings.company }}
					<input v-validate="'required'" :class="{'input': true, 'form--invalid': errors.has('company') }" type="text" :data-vv-as="strings.company" name="company" class="form__input" :placeholder="strings.company" v-model="ck_company" >
					<p v-show="errors.has('company')" class="form__note">{{ errors.first('company') }}</p>
					</label>

					<label class="form__label input-group__item">Company address
					<input v-validate="'required'" :class="{'input': true, 'form--invalid': errors.has('company_address') }" type="text" name="company_address" :data-vv-as="strings.address" class="form__input" placeholder="Company address" v-model="ck_company_address" >
					<p v-show="errors.has('company_address')" class="form__note">{{ errors.first('company_address') }}</p>
					</label>

					<label class="form__label input-group__item input-group__item_half input_group_item_first">City
					<input v-validate="'required'" :class="{'input': true, 'form--invalid': errors.has('company_city') }" type="text" name="company_city" :data-vv-as="strings.city" class="form__input" placeholder="City name" v-model="ck_company_city" >
					<p v-show="errors.has('company_city')" class="form__note">{{ errors.first('company_city') }}</p>
					</label>

					<label class="form__label input-group__item input-group__item_half">
						<div style="margin-bottom:3px;">Country</div>
						<RegusCountryListComponent ref="country_list" name="company_country" v-model="ck_company_country"/>
					</label>
					<div class="clearfix" v-if="zipIsNeeded || regusCountryISO == '36' || regusCountryISO == '840' || regusCountryISO == '76' || regusCountryISO == '484' || regusCountryISO == '124'"></div>
					<label class="form__label input-group__item input-group__item_half input_group_item_first" v-if="regusCountryISO == '36'">State
						<AustralianStateListComponent name="company_state" v-model="ck_company_state"/>
					</label>

					<label class="form__label input-group__item input-group__item_half input_group_item_first" v-if="regusCountryISO == '840'">State
						<AmericanStateListComponent name="company_state" v-model="ck_company_state"/>
					</label>

					<label class="form__label input-group__item input-group__item_half input_group_item_first" v-if="regusCountryISO == '76'">State
						<BrazilianStateListComponent name="company_state" v-model="ck_company_state"/>
					</label>

					<label class="form__label input-group__item input-group__item_half input_group_item_first" v-if="regusCountryISO == '484'">State
						<MexicanStateListComponent name="company_state" v-model="ck_company_state"/>
					</label>

					<label class="form__label input-group__item input-group__item_half input_group_item_first" v-if="regusCountryISO == '124'">State
						<CanadianStateListComponent name="company_state" v-model="ck_company_state"/>
					</label>

					<label class="form__label input-group__item input-group__item_half" v-if="zipIsNeeded">Post code / Zip
					<input v-validate="'required'" :class="{'input': true, 'form--invalid': errors.has('company_zip') }" type="text" :data-vv-as="strings.zip" name="company_zip" class="form__input" placeholder="Eg: 01120" v-model="ck_company_zip" >
					<p v-show="errors.has('company_zip')" class="form__note">{{ errors.first('company_zip') }}</p>
					</label>


				</div>
				<div class="clearfix"></div>
				<!--<label class="form__label input-group__item">{{ strings.additional_info }}  </label>
				<textarea
					class="form__textarea" name="additional_info"
					:placeholder="strings.additional_info_placeholder"
					v-model="ck_additional_info"
				></textarea>-->

				<div class="availableServices" v-if="services.length > 0">
					<h2 class="checkout-title"> {{ strings.availableServices }}   <span style="font-weight:400; color: #777777">{{ strings.optionalItems }}</span></h2>
					<b-table outlined hover :items="services" :fields="fields">
						<template v-slot:cell(service_price)="data">
							{{ data.value }}
						</template>
						<template v-slot:cell(amount)="data">
							<input min="0" class="form__input" type="number" :placeholder="strings.enterAmount" v-model="data.item.amount" />
						</template>
						<template v-slot:cell(service_time)="data" >
							<select class="form__input service_time_from"> 
								<option v-for="item in serviceTimeList" :key="item.id" :value="item.value"> {{ item.text }} </option> 
							</select>
						</template>
					</b-table>

				</div>
				<template>
					<div id="app" class="payment-info">
						<h2 class="checkout-title">{{ strings.plzGiveUsYourDetails }}</h2>
						<h4><font-awesome-icon icon="lock" />{{ strings.securePaymentInformation }}</h4>
						<div class="alert alert-success">
							{{ fullRefundText }}
						</div>
						<iframe ref="paymentIframe" @load="iframeLoad" scrolling="no" style="width: 100%; border:none;overflow: hidden;" height="400" :src="pciURL" ></iframe>
						<div id="payment_wrapper">
							<div class="checkBoxAgree">
								<input type="checkbox" id="checkboxAgree" v-model="checkboxAgree">
								<label for="checkboxAgree">{{ strings.haveRead }} 
									<a target="_blank" href="/terms">{{ strings.termsNConditions}}</a> {{ strings.and }} <a target="" @click.prevent="showModalCancellationPolicty=true" href="#">{{ strings.cancellationPolicy }}.</a></label>
							</div>
							<div v-if="bookingError" class="paymentError">
								{{bookingError}}
							</div>
							<button class='button button--success button--full tabs__button' type="submit" >{{ strings.payWithCC }}</button>
						</div>
					</div>
				</template>
			</div>
		<div class="col-lg-5 col-xl-5" style="border: 0px solid black" >
			<h2 class="checkout-title">{{ strings.bookingRequestSummary }}</h2>
			<carousel v-if="checkOutItems.roomPhoto.length" :perPage="1" :navigationEnabled="false" :paginationSize="15">
				<slide v-for="(item, key) in checkOutItems.roomPhoto" :key="key">
					<img :src="item" alt="">
				</slide>
			</carousel>
			<div class="checkout-room-title">
				<h3 style="text-align:center;"> {{ checkOutItems.venue }}</h3>
			</div>
			<div class="col-md-12 venue-details-item full-info">
				<div class="full-info-item">
					<div class="info-label">{{ strings.startTime }}</div>
					<div class="info">{{ checkOutItems.startD }}</div>
				</div>
				<div class="full-info-item">
					<div class="info-label">{{ strings.endTime}}</div>
					<div class="info">{{ checkOutItems.endD }}</div>
				</div>
				<div class="full-info-item">
					<div class="info-label">{{ strings.Room }}</div>
					<div class="info room-detail">{{ checkOutItems.room }}</div>
				</div>
				<div class="full-info-item" v-if="checkOutItems.package == ''">
					<div class="info-label del-price">{{ strings.roomHirePrice }}</div>
					<div class="info">{{ checkOutItems.roomPrice }} {{ checkOutItems.currencySymbol }}</div>
				</div>
				<div class="full-info-item" v-else>
					<div class="info-label del-price">{{ strings.pricePerDelegate }}</div>
					<div class="info">{{ checkOutItems.roomPrice }} {{ checkOutItems.currencySymbol }}</div>
				</div>
				<div class="full-info-item">
					<div class="info-label">{{ strings.Delegates }}</div>
					<div id="delegate_quantity" class="info"> {{ checkOutItems.delegates }}</div>
				</div>
				<div class="full-info-item">
					<div class="info-label">{{ strings.seatingOrder }}</div>
					<div class="info">{{ checkOutItems.layout }}</div>
				</div>

				<div class="total full-info-item addonTotal" v-show="addOnsTotalPrices > 0">
					<div class="info-label">{{ strings.services }}</div>
					<div class="info">{{ addOnsTotalPrices | round }} {{ checkOutItems.currencySymbol }}</div>
				</div>

				<div class="total full-info-item totalPrice">
					<div class="info-label" style="font-weight:700">{{ strings.total }} <span style="font-weight:400">({{ strings.inclVat }})</span></div>
					<div class="info" style="font-weight:700">{{ totalPrice | round }} {{ checkOutItems.currencySymbol }}</div>
				</div>

			</div>
			</div>
		</div>
		<ModalComponent v-if="showModal" @close="showModal = false">
			<h3 slot="header">{{ strings.error }}</h3>
			<div slot="body">
				<div class="modal__text" v-if="creditCardError">{{ strings.creditCardError }}</div>
				<div class="modal__text" v-else-if="validationError">{{ validationErrorString }}</div>
				<div class="modal__text" v-else>{{ strings.errorProcessingOrder }}</div> 
			</div>
			<div slot="footer">
				<button class="modal-default-button modal-default-button-ok" @click="reloadIframe()" v-if="creditCardError || validationError">
					{{ strings.ok }}
				</button>
				<button class="modal-default-button modal-default-button-ok" @click="closeAndGoToVenuePage()" v-else>
					{{ strings.backToVenue }}
				</button>
			</div>
		</ModalComponent>
		<ModalComponent v-if="showModalExpire" @close="showModalExpire = false">
			<h3 slot="header">{{ strings.bookingExpired }}</h3>
			<div slot="body">
				<div class="modal__text">{{ strings.bookingExpiredGoBack }}</div>
			</div>
			<div slot="footer">
				<button class="modal-default-button modal-default-button-ok" @click="closeAndGoToVenuePage()">
                {{ strings.backToVenue }}
              </button>
			</div>
		</ModalComponent>
		<ModalComponent class="cancellationPolicyModal" v-if="showModalCancellationPolicty" @close="showModalCancellationPolicty = false">
			<h3 slot="header">Cancellation Policy</h3>
			<div slot="body">
				<div class="modal__text">
					<ul>
						<li>1-10 people: Full refund if cancelled 5 or more days in advance. No refund/credits if less than 5 days</li>
						<li>11-20 people: Full refund if cancelled 10 or more days in advance. No refund/credits if less than 10 days</li>
						<li>21+ people: Full refund if cancelled 20 or more days in advance. No refund/credits if less than 20 days</li>
					</ul>
					<p>
					* For future bookings cancelled within two hours of making the booking, no cancellation fee will apply.
					</p>
				</div>
			</div>
			<div slot="footer">
				<button class="modal-default-button modal-default-button-ok" @click.prevent="showModalCancellationPolicty = false">
                Close
              </button>
			</div>
		</ModalComponent>
		</form>
	</div>
	<div class="emptyCart" v-if="showEmptyCart && !done">
		<h1 class="emptyCartText">{{ strings.yourBookingExpired }}</h1>
	</div>
	<div v-if="done">
		<section class="main-section">
			<div class="checkout-complete-hero">
				<div class="cc-text">
					<div class="checkout-complete-text checkout-complete-text__large">Thank you!</div>
					<div class="checkout-complete-text checkout-complete-text__medium js-instant-booking">Your booking has been confirmed!</div>
					<div v-if="!userHasAccount" class="checkout-complete-text"><i class="fa fa-check green" aria-hidden="true"></i> You will receive login details in your email!  <i class="fa fa-envelope-o green" aria-hidden="true"></i></div>
					<div v-if="!userHasAccount" class="checkout-complete-text"><i class="fa fa-check green" aria-hidden="true"></i> Click on the link in the email & set password.</div>
					<div class="checkout-complete-text">please follow the steps below to</div>
                    <div class="checkout-complete-text checkout-complete-text__medium checkout-complete-text__green">Manage your order</div>
					<div class="checkout-complete-text">Easy, commitment free, no booking fees</div>
				</div>
				<div class="triptych-items row">
					<div class="triptych-item col-md-4">
						<div class="triptych-item-number">1</div>
						<div class="triptych-item-icon"><i class="fa fa-envelope-o green" aria-hidden="true"></i></div>
						<div class="triptych-item-text checkout-complete-text checkout-complete-text__medium checkout-complete-text__green">Receive an email</div>
						<div class="checkout-complete-text checkout-complete-text__small">with the request summary</div>
					</div>
					<div class="triptych-item col-md-4">
						<div class="triptych-item-number">2</div>
						<div class="triptych-item-icon"><i class="fa fa-file-text-o" aria-hidden="true"></i></div>
						<div class="triptych-item-text checkout-complete-text checkout-complete-text__medium  checkout-complete-text__green">Manage your order</div>
						<div class="checkout-complete-text checkout-complete-text__small">Amend for more delegates, request for more service <br/> Venue gets notified right away</div>
					</div>
					<div class="triptych-item col-md-4">
						<div class="triptych-item-number">3</div>
						<div class="triptych-item-icon"><i class="fa fa-check-circle" aria-hidden="true"></i></div>
						<div class="triptych-item-text checkout-complete-text checkout-complete-text__medium checkout-complete-text__green">Ready for meeting!</div>
						<div class="checkout-complete-text checkout-complete-text__small">Booking a meeting has never been so easy and our service is entirely free of cost </div>
					</div>
				</div>
				<div class="button-home" v-if="!userHasAccount">
					<a :href="lang + '/'">Make another enquiry</a>
				</div>
			</div>

		</section>

		        <!-- Your order number block -->
        <section id="block-system-main" class="block block-system clearfix regus-thankyou" v-if="userHasAccount">
            <div>
                <div class="checkout_completion_message form-wrapper form-group" id="edit-checkout-completion-message">
                    <div class="checkout-completion-message">
                        <p class="checkout-complete-text checkout-complete-text__medium checkout-complete-text__blue">Your
                            order number </p>
                        <p class="checkout-complete-text checkout-complete-text__large checkout-complete-text__green">{{ orderID }}</p>
                        <div class="circle-items row">
                            <div class="circle-item circle-item__blue">
                                <a :href="orderSuccessURL">View your <br>order here</a>
                            </div>
                            <div class="circle-item circle-item__blue">
                                <a :href="baseURLWithLang">Return <br>to <br>front page</a>
                            </div>
                            <div class="circle-item circle-item__blue">
                                <a :href="baseURLWithLang">Make <br>another <br>enquiry</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
		<div id="abc" v-if="bookingOrMP">
			<div style="text-align: center; margin: 20px;">
                <div class="checkout-complete-text" style="color: #003366;">Would you also need accommodation?</div>
                <div class="checkout-complete-text" style="color: #003366;">Below you can see nearby available accommodation options. Let us know if you need any help!</div>
            </div>
		</div>		
	</div>
</div>

  
</template>

<script>
import VuePhoneInput from './VuePhoneInput'
import Multiselect from 'vue-multiselect'
import * as hf from '../assets/misc/helperFunctions.js'
import moment from 'moment';
import Vue from 'vue'
import VueResource from 'vue-resource';
import ModalComponent from './ModalComponent';
import RegusCountryListComponent from './RegusCountryList';
import AustralianStateListComponent from './statelist/Australia';
import AmericanStateListComponent from './statelist/America';
import BrazilianStateListComponent from './statelist/Brazil';
import MexicanStateListComponent from './statelist/Mexico';
import CanadianStateListComponent from './statelist/Canada';
import VueTimepicker from 'vue2-timepicker'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faLock } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { stripeKey, stripeOptions } from './stripeConfig.json'
import { Card, createToken } from 'vue-stripe-elements-plus'
import VeeValidate from 'vee-validate';


library.add(faLock)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VeeValidate);
Vue.use(VueResource);

export default {
	data () {
		return {
			valueService: [],
			options: [],
			ck_name: typeof this.$store.state.userInfo.first_name == 'undefined' ? '' : this.$store.state.userInfo.first_name,
			ck_lname: typeof this.$store.state.userInfo.last_name == 'undefined' ? '' : this.$store.state.userInfo.last_name,
            ck_cardholdername: '',
            ck_email: typeof this.$store.state.userInfo.email == 'undefined' ? '' : this.$store.state.userInfo.email,
			ck_phone: typeof this.$store.state.userInfo.phone == 'undefined' ? '' : this.$store.state.userInfo.phone,
			ck_company: typeof this.$store.state.userInfo.company == 'undefined' ? '' : this.$store.state.userInfo.company,
			ck_additional_info: '',
			ck_company_address: '',
			ck_company_country: '',
			ck_company_city: '',
			ck_company_state: '',
			ck_company_zip: '',
			totalPrice : 0,
            servicesHasAtLeastOneTime: false,
			roomTotalPrice: 0,
			localMiscItems: this.$store.state.operaMiscItems,
			checkboxAgree: false,
            complete: false,
            bookingError: false,
            isHidden: true,
			timer: '',
			checkOutItems: {},
			showModal: false,
			creditCardError: false,
			showEmptyCart: false,
			showModalExpire: false,
			showModalCancellationPolicty: false,
			venue_id: '',
			services: [],
			fields: [
				{ key: 'service_name', label: 'Service Name' , class: 'nameCol' },
				{ key: 'service_price', label: 'Service Price' , class: 'priceCol' },
				{ key: 'amount', label: 'Amount', class: 'amountCol' },
				{ key: 'service_time', label: 'Service Time', class: 'timeCol' },
			],
			done: false,
			userHasAccount: 0,
			orderID: '',
			pciURL: '',
			baseURLWithLang: '',
			orderSuccessURL: '',
			fullRefundText: 'Bookings cancelled within two hours of making the booking, no cancellation fee will apply.',
			newAccessToken: 111,
			validationErrorString: '',
			serviceTimeList: [
				{ id : 1, text: "--:--", value: "--:--" }, 
				{ id : 2, text: "00:00", value: "00:00" }, 
				{ id : 3, text: "00:30", value: "00:30" }, 
				{ id : 4, text: "01:00", value: "01:00" }, 
				{ id : 5, text: "01:30", value: "01:30" }, 
				{ id : 6, text: "02:00", value: "02:00" }, 
				{ id : 7, text: "02:30", value: "02:30" }, 
				{ id : 8, text: "03:00", value: "03:00" }, 
				{ id : 9, text: "03:30", value: "03:30" }, 
				{ id : 10, text: "04:00", value: "04:00" }, 
				{ id : 11, text: "04:30", value: "04:30" }, 
				{ id : 12, text: "05:00", value: "05:00" }, 
				{ id : 13, text: "05:30", value: "05:30" }, 
				{ id : 14, text: "06:00", value: "06:00" }, 
				{ id : 15, text: "06:30", value: "06:30" }, 
				{ id : 16, text: "07:00", value: "07:00" }, 
				{ id : 17, text: "07:30", value: "07:30" }, 
				{ id : 18, text: "08:00", value: "08:00" }, 
				{ id : 19, text: "08:30", value: "08:30" }, 
				{ id : 20, text: "09:00", value: "09:00" }, 
				{ id : 21, text: "09:30", value: "09:30" }, 
				{ id : 22, text: "10:00", value: "10:00" }, 
				{ id : 23, text: "10:30", value: "10:30" }, 
				{ id : 24, text: "11:00", value: "11:00" }, 
				{ id : 25, text: "11:30", value: "11:30" }, 
				{ id : 26, text: "12:00", value: "12:00" }, 
				{ id : 27, text: "12:30", value: "12:30" }, 
				{ id : 28, text: "13:00", value: "13:00" }, 
				{ id : 29, text: "13:30", value: "13:30" }, 
				{ id : 30, text: "14:00", value: "14:00" }, 
				{ id : 31, text: "14:30", value: "14:30" }, 
				{ id : 32, text: "15:00", value: "15:00" }, 
				{ id : 33, text: "15:30", value: "15:30" }, 
				{ id : 34, text: "16:00", value: "16:00" }, 
				{ id : 35, text: "16:30", value: "16:30" }, 
				{ id : 36, text: "17:00", value: "17:00" }, 
				{ id : 37, text: "17:30", value: "17:30" }, 
				{ id : 38, text: "18:00", value: "18:00" }, 
				{ id : 39, text: "18:30", value: "18:30" }, 
				{ id : 40, text: "19:00", value: "19:00" }, 
				{ id : 41, text: "19:30", value: "19:30" }, 
				{ id : 42, text: "20:00", value: "20:00" }, 
				{ id : 43, text: "21:00", value: "21:00" }, 
				{ id : 44, text: "20:30", value: "20:30" }, 
				{ id : 45, text: "21:30", value: "21:30" }, 
				{ id : 46, text: "22:00", value: "22:00" }, 
				{ id : 47, text: "22:30", value: "22:30" }, 
				{ id : 48, text: "23:00", value: "23:00" }, 
				{ id : 49, text: "23:30", value: "23:30" },
			]
		}
	},
	created () {
		this.$store.commit('setProcessing', 'yes');
	},
	mounted () {
		let duration = 20 * 60;
		let minutes, seconds;

		// Get Checkout Items.
		let checkOutItems = JSON.parse(this.$cookie.get('checkout_items'));
		let _services = JSON.parse(localStorage.getItem('services'));
		if(checkOutItems){
			this.venue_id = checkOutItems.venue_id;
			let regusCartExpirationCookie = this.$cookie.get('regus_cart_expiration');
			if(regusCartExpirationCookie){
				let regusCartExpiration = moment(regusCartExpirationCookie, 'DD-MM-YYYY HH:mm');
				let currentTime = moment();
				let diffTime = regusCartExpiration.diff(currentTime, 'seconds');
				duration = diffTime;
			} else {
				this.$cookie.set('regus_cart_expiration', moment().add(20, 'minutes').format('DD-MM-YYYY HH:mm:ss') , { expires: '20m' });
			}
			
			let countDownInterval = setInterval(() => {
				minutes = parseInt(duration / 60, 10)
				seconds = parseInt(duration % 60, 10);

				minutes = minutes < 10 ? "0" + minutes : minutes;
				seconds = seconds < 10 ? "0" + seconds : seconds;
				duration--;
				if(duration >= -1){
					this.timer = minutes + ":" + seconds;
				} else {
					clearInterval(countDownInterval);
					this.$cookie.delete('checkout_items');
					localStorage.removeItem('services');
					this.showModalExpire = true;
					//window.history.back();	
				}

			}, 1000);

			this.roomTotalPrice = parseFloat(checkOutItems.roomTotalPrice);
			this.totalPrice = parseFloat(checkOutItems.roomTotalPrice);		
			_services.forEach(element => {
				if(element.service_time_type == 'NoTime'){
					element.service_time = ''
				} else {
				    this.servicesHasAtLeastOneTime = true;
					element.service_time = checkOutItems.startT
				}
			});
			if(this.servicesHasAtLeastOneTime  == false){
                this.fields = this.fields.filter(function(el) {
						return el.key !== "service_time";
					});
			}
			this.checkOutItems = checkOutItems;
			this.services = _services;
      		let site_url = window.location.protocol + '//' + window.location.hostname + window.mp_url_settings["BASE_URL"];
			let lang = this.$store.state.selectedLang;
			//let brandName = 'meetingpackagetest_sandbox';
			let brandName = 'MeetingPackage';
			//let accessToken = JSON.parse(localStorage.getItem('accessToken'));
			let accessToken = window.pciAccessToken;
			let successURL = site_url + '/apiv2/getcardtoken/success?cardToken={cardToken}';
			let failureURL = site_url + '/apiv2/getcardtoken/failure';
			successURL = encodeURIComponent(successURL);
			failureURL = encodeURIComponent(failureURL);

			//this.pciURL = 'https://cf-service.pcibooking.net/api/payments/capturecard';
			this.pciURL = 'https://service.pcibooking.net/api/payments/capturecard';
			this.pciURL += '?brand=' + brandName;
			this.pciURL += '&accessToken=' + accessToken;
			this.pciURL += '&cvv=true';
			this.pciURL += '&success=' + successURL;
			this.pciURL += '&failure=' + failureURL;
			this.pciURL += '&submitWithPostMessage=true';
			this.pciURL += '&language=' + lang;
			this.pciURL += '&autoDetectCardType=' + 'true';
			this.pciURL += '&autoFocus=' + 'false';
			this.pciURL += '&css=' + 'PCI_Style';

		} else {
			this.showEmptyCart = true;
		}

		if (window.addEventListener) {
			window.addEventListener('message', this.handleFrameMessage);
		}
		else if (window.attachEvent) {
			window.attachEvent('onmessage', this.handleFrameMessage);
		}

		// Get User Info (if there is)
		this.$store.dispatch('checkUser').then(() => {
			let userInfo = this.$store.state.userInfo;
			if(userInfo){
				this.ck_name = userInfo.first_name;
				this.ck_lname = userInfo.last_name;
				this.ck_email = userInfo.email;
				this.ck_phone = userInfo.phone;
				this.ck_company = userInfo.company;
			}
			this.$store.commit('setProcessing', 'no');
		});
		// If booking.com here we set some cookies for the thank you page.
		let site_url = window.location.host;
		if(site_url == 'booking.meetingpackage.com' || site_url == 'meetingpackage.com'){
			/*var g = document.createElement('div');
			g.setAttribute("id", "b_container");
			document.getElementById("abc").appendChild(g);
			let check_in_date = this.checkOutItems.startD ? moment(this.checkOutItems.startD, 'DD-MM-YYYY').format('YYYY-MM-DD') : '';
			let check_out_date = check_in_date ? moment(check_in_date, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD') : '';
			let fake_latlng = '60.2052,24.6522';
			let latlon = this.$store.state.venueInfo ? this.$store.state.venueInfo.latlon.split(',') : fake_latlng.split(',');
			let latitude = latlon[0];
			let longitude = latlon[1];
			var booking_script = document.createElement('script');
			var source = 'https://aff.bstatic.com/static/affiliate_base/js/booking_sp_widget.js?label=eventdetail-mapwidget-1593749-view_brand-meetingpackage&label_click=eventdetail-mapwidget-1593749-click_brand-meetingpackage&checkin=' + check_in_date + '&checkout=' + check_out_date + '&latitude=' + latitude + '&longitude=' + longitude + '';
			booking_script.setAttribute('src', source);
			booking_script.setAttribute('id','sp_widget');
			booking_script.setAttribute('data-hash','_a8bf2efe573098');
			booking_script.setAttribute('data-container','b_container');
			booking_script.setAttribute('data-size','100%x600px');
			booking_script.setAttribute('data-tpncy','false');
			document.head.appendChild(booking_script);
			*/
		}

		// Full refund upto stuff.
		/*let delegates = parseInt(this.checkOutItems.delegates);
		let workingDays = ''
		if(delegates <= 10){
			workingDays = '6';
		} else if(delegates >= 11 && delegates <= 49){
			workingDays = '11';
		} else {
			workingDays = '29';
		}

        let dateNow = moment(new Date());//now
        let eventStartDate = moment(this.checkOutItems.startD, 'DD-MM-YYYY');
		if(eventStartDate.diff(dateNow, 'days') < workingDays){
            this.fullRefundText = 'Cancelation fees may apply.';
		}else{
            this.fullRefundText = '100% free cancellation up to ' + workingDays + ' working days before your meeting';
		}*/
		document.onreadystatechange = () => { 
			if (document.readyState == "complete") { 
				let footerEl = document.getElementById("footer");
				if(footerEl){
					footerEl.style.display = "block";
				}
			} 	
		}
	},
	components: {
		VuePhoneInput,
		Multiselect,
		ModalComponent,
		VueTimepicker,
		Card,
		RegusCountryListComponent,
		AustralianStateListComponent,
		AmericanStateListComponent,
		CanadianStateListComponent,
		BrazilianStateListComponent,
		MexicanStateListComponent
	},
	computed: {
		strings(){
            return this.$store.state.strings;
		},
		zipIsNeeded(){
			return this.$store.state.regusZipMandatory;
		},
		regusCountryISO(){
			return this.$store.state.regusCountry;
		},
		addOnsTotalPrices(){
			let total = 0;
			if(this.services.length == 0){
				return total;
			} else {
				this.services.forEach(element => {
					let amount = element.amount ? element.amount : 0;
					total += element.service_price_value * parseInt(amount);
				});

				return total;
			}
		},
		bookingOrMP(){
			let site_url = window.location.origin;
			if(site_url == 'booking.meetingpackage.com' || site_url == 'meetingpackage.com'){
				return true;
			} else {
				return false;
			}
		}
	},
	watch: {
		addOnsTotalPrices: function(value) {
			if(value > 0) {
				this.totalPrice = this.roomTotalPrice + value;
			} else {
				this.totalPrice = this.roomTotalPrice;
			}
		}
	},
	methods: {
        checkForm: function (e) {
            e.preventDefault();
			this.bookingError = "";

			let self = this;
			
			var receiver = self.$refs.paymentIframe.contentWindow;

            this.$validator.validateAll().then((result) => {
				self.$refs.country_list.$validator.validateAll().then((childResult) => {
					var host = 'https://service.pcibooking.net/';
					if(result & childResult){
						if(this.checkboxAgree == false) {
							this.bookingError = "Please agree to the terms.";
						}else{
							//this.$store.commit('setProcessing', 'yes');
							//this.pay();

							receiver.postMessage("validate", host);
						}
					}else{
						this.bookingError = "Please fix the errors above.";
					}
				});
            });
        },
        pay () {
            if(this.complete == false) {
				this.bookingError = "Please add your credit card number.";
				this.$store.commit('setProcessing', 'no');
                return;
            }
            createToken().then(
				(data) => {
                    let sentData = {};
                    sentData.start = this.checkOutItems.startD;
                    sentData.end = this.checkOutItems.endD;
                    sentData.delegates = this.checkOutItems.delegates;

                    sentData.company = this.ck_company;
                    sentData.firstName = this.ck_name;
                    sentData.lastName = this.ck_lname;
                    sentData.cardholdername = this.ck_cardholdername;
                    sentData.phone = this.ck_phone;
                    sentData.email = this.ck_email;
                    sentData.phone_country = '';
                    sentData.additional_info = this.ck_additional_info;

                    sentData.room_code = this.checkOutItems.room_code;
                    sentData.room_name = this.checkOutItems.room;
                    sentData.layout = this.checkOutItems.layout;
                    sentData.currency = this.checkOutItems.currency;
                    sentData.price = this.checkOutItems.roomTotalPrice;
                    sentData.price_no_vat = this.checkOutItems.roomPrice_NoVAT;
                    sentData.price_total = this.checkOutItems.roomTotalPrice;
                    sentData.venue_id = this.checkOutItems.venue_id;
                    sentData.venue_id = this.checkOutItems.venue_id;
                    sentData.token = data.token.id;
                    let services = this.services
									.filter(service => service.amount > 0)
                    sentData.services = services;
                    sentData.temporary_reservation_id = this.checkOutItems.reservationID;
                    this.createRegusBooking(sentData);
                }
			);
		},
		payWithPCIBooking(cardToken) {
			let sentData = {};
			sentData.start = this.checkOutItems.startD;
			sentData.end = this.checkOutItems.endD;
			sentData.delegates = this.checkOutItems.delegates;

			sentData.company = this.ck_company;
			sentData.firstName = this.ck_name;
			sentData.lastName = this.ck_lname;
			sentData.cardholdername = this.ck_cardholdername;
			sentData.phone = this.ck_phone;
			sentData.email = this.ck_email;
			sentData.phone_country = '';
			sentData.additional_info = this.ck_additional_info;

			sentData.room_code = this.checkOutItems.room_code;
			sentData.room_name = this.checkOutItems.room;
			sentData.layout = this.checkOutItems.layout;
			sentData.currency = this.checkOutItems.currency;
			sentData.price = this.checkOutItems.roomTotalPrice;
			sentData.price_no_vat = this.checkOutItems.roomPrice_NoVAT;
			sentData.price_total = this.checkOutItems.roomTotalPrice;
			sentData.venue_id = this.checkOutItems.venue_id;
			sentData.venue_id = this.checkOutItems.venue_id;

			// Address fields.
			sentData.address = this.ck_company_address;
			sentData.city = this.ck_company_city;
			sentData.zip = this.ck_company_zip;
			sentData.country_number = this.$store.state.regusCountry;
			if(this.$store.state.regusStateMandatory){
				sentData.state = this.$store.state.regusState;
			} else {
				sentData.state = '';
			}

			//sentData.token = data.token.id;
			let services = this.services
							.filter(service => service.amount > 0)
			sentData.services = services;
			sentData.temporary_reservation_id = this.checkOutItems.reservationID;
			sentData.cardToken = cardToken;
			this.createRegusBooking(sentData);
		},
		createRegusBooking(sentData) {

			let baseUrl = window.location.origin;
			
			let lang = this.$store.state.selectedLang;
			if(lang == 'en'){
				lang = '';
			} else {
				lang = '/' + lang;
			}
			
			let ajaxUrl = '';
			
			ajaxUrl = '/apiv2/regus/book';


            Vue.http.post(ajaxUrl, sentData).then(response => {
                let url = '';
				if(response.body.order_id){

					let orderID = response.body.order_id;
					let userHasAccount = response.body.user_has_account;

					this.done = true;
					this.orderID = orderID;
					this.userHasAccount = userHasAccount;

					url = baseUrl + lang + '/book/' + orderID + '/success';

					this.orderSuccessURL = baseUrl + lang + '/dashboard/inbox' + orderID;

					this.baseURLWithLang = baseUrl + lang ;

					// Create some cookie.
					this.$cookie.set('order_id', orderID);
					this.$cookie.set('user_has_account', userHasAccount);

					// #deleteCookie
					this.$cookie.delete('checkout_items');
					this.$cookie.delete('regus_cart_expiration');
					localStorage.removeItem('services');
					// Go to Thank you page.

					//window.location.href = url;
					window.history.pushState(null, null, url);
					this.$store.commit('setProcessing', 'no');
				} else {
					this.$store.commit('setProcessing', 'no');
					this.showModal = true;

					// Different error message.
					if(response.body.error_type){

						if(response.body.error_type == 'payment'){
							this.creditCardError = true;
							this.newAccessToken = response.body.accesstoken;
						} else if(response.body.error_type == 'validation'){
							this.validationError = true;
							this.newAccessToken = response.body.accesstoken;
							this.validationErrorString = response.body.message;
						} else {
							this.creditCardError = false;
							this.validationError = false;
							// #deleteCookie
							this.$cookie.delete('checkout_items');
							this.$cookie.delete('regus_cart_expiration');
							localStorage.removeItem('services');
						}

					} else {
						this.creditCardError = false;
						this.validationError = false;
						// #deleteCookie
						this.$cookie.delete('checkout_items');
						this.$cookie.delete('regus_cart_expiration');
						localStorage.removeItem('services');
					}

				}
            }, function (error) {
				this.$store.commit('setProcessing', 'no');
                if (error.response.status === 400) {
                    this.bookingError = response.body.message;
                }
            });
		},
		closeAndGoToVenuePage() {
			let baseUrl = window.location.origin;
			let lang = this.$store.state.selectedLang;
			if(lang == 'en'){
				lang = '/';
			} else {
				lang = '/' + lang + '/';
			}

			let venue_url = baseUrl + lang + 'node' + '/' + this.venue_id;

			this.$cookie.delete('checkout_items');
			this.$cookie.delete('regus_cart_expiration');
			localStorage.removeItem('services');
			this.$emit('close');

			window.location.href = venue_url;	
		},
		reloadIframe() {

			let self = this;

			this.showModal = false;

      		let site_url = window.location.protocol + '//' + window.location.hostname + window.mp_url_settings["BASE_URL"];
			let lang = this.$store.state.selectedLang;
			//let brandName = 'meetingpackagetest_sandbox';
			let brandName = 'MeetingPackage';
			//let accessToken = JSON.parse(localStorage.getItem('accessToken'));
			let accessToken = this.newAccessToken;

			let successURL = site_url + '/apiv2/getcardtoken/success?cardToken={cardToken}';
			let failureURL = site_url + '/apiv2/getcardtoken/failure';
			successURL = encodeURIComponent(successURL);
			failureURL = encodeURIComponent(failureURL);

			//this.pciURL = 'https://cf-service.pcibooking.net/api/payments/capturecard';
			this.pciURL = 'https://service.pcibooking.net/api/payments/capturecard';
			this.pciURL += '?brand=' + brandName;
			this.pciURL += '&accessToken=' + accessToken;
			this.pciURL += '&cvv=true';
			this.pciURL += '&success=' + successURL;
			this.pciURL += '&failure=' + failureURL;
			this.pciURL += '&submitWithPostMessage=true';
			this.pciURL += '&language=' + lang;
			this.pciURL += '&autoDetectCardType=' + 'true';
			this.pciURL += '&autoFocus=' + 'false';
			this.pciURL += '&css=' + 'PCI_Style';

			self.$refs.paymentIframe.contentWindow.location.reload();
			//location.reload();	
		},
		iframeLoad() {
			let self = this;

			let callBackURL = self.$refs.paymentIframe.contentWindow.location.href;
			callBackURL = decodeURIComponent(callBackURL);
			let indexToken = callBackURL.indexOf('cardToken');
			let cardToken = callBackURL.substr(indexToken + 10);

			// Encode Card Token.

			cardToken = encodeURIComponent(cardToken);

			if(cardToken){
				self.payWithPCIBooking(cardToken);
			} else {
				// No card token, should show error message.
				this.$store.commit('setProcessing', 'no');
				this.showModal = true;
				// #deleteCookie
				this.$cookie.delete('checkout_items');
				this.$cookie.delete('regus_cart_expiration');
			}

		},
		handleFrameMessage(e) {
			let self = this;
			var receiver = self.$refs.paymentIframe.contentWindow;
			var host = 'https://service.pcibooking.net/';
			var originDomain = e.origin.replace("http://", "").replace("https://", "");
			var postMessageOrigin = host.replace("http://", "").replace("https://", "").toLowerCase();
			if (postMessageOrigin.endsWith('/'))
				postMessageOrigin = postMessageOrigin.substring(0, postMessageOrigin.length - 1);

			
			if (originDomain.toLowerCase() === postMessageOrigin) {
				if (e.data == 'ready') {
					iframeIsReady = true;
				}
				else if (e.data == 'valid') {
					//continueSubmitReservationAndThenCardIframe(e);
					this.$store.commit('setProcessing', 'yes');
					receiver.postMessage('submit', host);
				}
				else if (e.data.indexOf("frameDimensionsChanged") === 0) {
					var objectParts = e.data.split(':');
					var width = parseInt(objectParts[1]);
					var height = parseInt(objectParts[2]);
				}
				else if (e.data[0] === "{") {
				}
				else {
					//alert("Please fill all the mandatory fields");
				}
			}
		}
	}
}
</script>


<style scoped>
	.info-label {
		float: left;
		width: 50%;
	}

	.info {
		float: left;
		width: 50%;
		text-align: right;
	}

	.full-info-item {
		margin-bottom: 20px;
		padding-bottom: 10px;
	}

	.checkout-title {
		border-bottom: 1px solid black;
		margin-bottom: 20px;
	}

	img {
		width: 100%;
		height: 270px;
	}

	.room-pic, .checkout-room-title {
		padding-bottom: 10px;
		border-bottom: 1px solid #ccc;
		margin-bottom: 10px;
	}

	.totalPrice {
		border-top: 1px solid #ccc;
		padding-top: 20px;
	}

	.addonTotal {
		border-top: 1px solid #ccc;
		padding-top: 15px;
	}

	.form__note {
		top: 22px;
	}

	.form__label {
		font-size: 16px;
	}

	.form__textarea {
		height: 150px;
		font-size: 14px;
	}

	form {
		margin-bottom: 50px;
	}

	.multiselect {
		margin-bottom: 20px;
	}

	.multiselect__tag {
		background: #0055a9
	}

	.multiselect__tag-icon:after {
		color: white;
	}

	.checkBoxAgree {
		margin-bottom: 20px !important;
	}
	.paymentError{
		margin-left: 20px;
		margin-top: -10px;
		color: red;
	}
	.time-picker {
		width: 5em;
	}

</style>
<style>
	#securedByImgContainer {
		display: none;
	}
	.amountInput {
		width: 20% !important;
	}
	.tableCellClass{
		vertical-align: middle !important;
	}
	.emptyCart {
		height: 700px;
		text-align: center;
	}

	.emptyCartText {
		line-height: 700px;
	}

	.nameCol {
		width: 40%;
		vertical-align: middle !important;
	}

	.priceCol {
		width: 25%;
		vertical-align: middle !important;
	}

	.amountCol {
		width: 15%;
		vertical-align: middle !important;
	}

	.timeCol {
		width: 20%;
		vertical-align: middle !important;
	}
	/**
     * The CSS shown here will not be introduced in the Quickstart guide, but shows
     * how you can use CSS to style your Element's container.
     */
	.StripeElement {
		background-color: white;
		height: 40px;
		padding: 10px 12px;
		border-radius: 4px;
		border: 1px solid transparent;
		box-shadow: 0 1px 3px 0 #e6ebf1;
		-webkit-transition: box-shadow 150ms ease;
		transition: box-shadow 150ms ease;
	}

	.StripeElement--focus {
		box-shadow: 0 1px 3px 0 #cfd7df;
	}

	.StripeElement--invalid {
		border-color: #fa755a;
	}

	.StripeElement--webkit-autofill {
		background-color: #fefde5 !important;
	}
	.stripe-card {
		width: 300px;
		border: 1px solid grey;
	}
	.stripe-card.complete {
		border-color: green;
	}
	.checkBoxAgree{
		margin-top: 40px!important;
		padding-top: 20px;
		border-top: 2px solid #eaeaea;
	}
	.input-group__item_half {
		width: calc(50% - 10px);
		float:left;
	}
	#regus_country_list{
		
	}
	input[name=company_country] {
		margin-top: 4px!important;
	}
	.input_group_item_first{
		margin-right:20px;
	}
	.payment-info h4{
		padding-bottom: 0px!important;
		font-size: 14px!important;
		text-transform: uppercase;
		border-bottom: none!important;
	}
	.payment-info h4 svg{
		margin-right: 5px;
	}
	.InputElement {
		 height: 1.2em!important;
	}
	input[type="text"].cardHolderName::-webkit-input-placeholder {
		font-size:16px;
		color:#B0BCC8;
	}
	#statelist{
		margin-top:4px;
	}
	.cardHolderName{
		color: #32325d;
		line-height: 24px;
		font-family: Helvetica Neue;
		font-size: 16px;
		 height: auto;
		padding:9px;
		padding-left: 15px;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}
	.cancellationPolicyModal .modal-container {
		width: 800px !important;
	}
	.cancellationPolicyModal .modal__text {
		text-align: left !important;
	}

	.cancellationPolicyModal ul{
		padding-left: 16px !important;
	}
</style>
